import { useSiteContext } from '@eti/providers';
import { useEffect } from 'react';
import { analytics } from '@eti/utils';
import type { Product, TravelerPrice } from '../../../../pages/traveler-details/models';
import { getAirProduct, getBundleProducts } from '../utils';
import type { Bundles } from '../models';
import { getExtraProducts } from './useEcomPurchaseDataLayerEffect';

export const useBeginCheckoutDataLayerEffect = (
  bundles: Bundles,
  products: Product[],
  travelerPrices: TravelerPrice[],
  isPaymentLinkCart: boolean = false,
) => {
  const { siteCurrency } = useSiteContext();

  useEffect(() => {
    const { dataLayer } = window;
    if (!dataLayer) {
      return;
    }

    const items = [
      ...(isPaymentLinkCart ? [] : [getAirProduct(travelerPrices, siteCurrency.exponent)]),
      ...getBundleProducts(bundles, siteCurrency),
      ...getExtraProducts(products, siteCurrency.exponent),
    ].map((item, index) => ({ ...item, index }));

    const totalValue = items.reduce((acc, item) => acc + item.price, 0);
    const beginCheckoutEvent = {
      event: 'begin_checkout',
      ecommerce: {
        currency: siteCurrency.code,
        value: totalValue,
        items,
      },
    };

    analytics.pushEntryToDataLayer({ ecommerce: null });
    analytics.pushEntryToDataLayer(beginCheckoutEvent, false);
  }, [bundles, products, siteCurrency, travelerPrices, isPaymentLinkCart]);
};
